import React, {useEffect, useState} from 'react';
import ProgramRatingView from "../../views/ver_24.10/ProgramRating/DQRating/DQProgramRating.view";
import {useHistory} from "react-router-dom";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import {
    registerRatingFingerprintService,
    fetchRatingFingerprintService,
    uploadMedia, submitProgramDataPublicService
} from "../../services/rating_public.service";
import {v4 as uuidv4} from "uuid";
import LoaderBackDropWithPercentage from "../../components/LoaderWithBackDrop/LoaderBackDropWithPercentage.comp";

const ProgramRatingMain = () => {
    const [showLoader, setShowLoader] = useState(false);
    const history = useHistory();
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadedFilesPath, setUploadedFilesPath] = useState([]);

    useEffect(() => {
        setShowLoader(true);
        initializeProgramApplication().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const initializeProgramApplication = async () => {
        setShowLoader(true);
        const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_rating_fingerprint);
        if (fingerprint) {
            await fetchProgramApplication(fingerprint);
        } else {
            const newFingerprint = await createFingerprint();
            console.log('Generated fingerprint:', newFingerprint);
            localStorage.setItem(LOCAL_STORAGE_KEYS.user_rating_fingerprint, newFingerprint);
            await registerFingerprint(newFingerprint);
        }
        setShowLoader(false);
    };

    const fetchProgramApplication = async (fingerprint) => {
        try {
            const response = await fetchRatingFingerprintService(fingerprint);
            if (response.data && response.data.program_application) {
                console.log('finger print fetched successfully');
                console.log('program_application: ', response.data.program_application);
            }
        } catch (e) {
            // already toasted the error
        }
    };

    // Create a unique fingerprint for the user
    const createFingerprint = async () => {
        return uuidv4();
    };

    // Register the new fingerprint on the server
    const registerFingerprint = async (fingerprint) => {
        try {
            const response = await registerRatingFingerprintService(fingerprint);
            if (response.data && response.data.program_application) {
                console.log('fingerprint registered successfully');
                console.log('program_application: ', response.data.program_application);
            }
        } catch (e) {
            // already toasted the error
        }
    }

    const uploadSingleFile = async (fingerprint, file, index, totalFiles) => {
        const formData = new FormData();
        formData.append('fingerprint_id', fingerprint);
        formData.append('media', file);

        try {
            const result = await uploadMedia(formData, (progressEvent) => {
                const uploadPercentage = Math.floor(
                    ((progressEvent.loaded / progressEvent.total) * 100) / totalFiles +
                    (index / totalFiles) * 100
                );
                setUploadProgress(uploadPercentage);
            });
            if (result.data) {
                const { media_path } = result.data;
                console.log(`File uploaded: ${media_path}`);
                setUploadedFilesPath((prevFilesPath) => [...prevFilesPath, media_path]);
                setUploadedFiles((prevFiles) => [...prevFiles, file]);
            }
        } catch (e) {
            console.error('Error uploading file', e);
        }
    };

    const data = {
        uploadedFiles,
    };

    // Actions handling business logic
    const actions = {
        uploadFileAction: async (files) => {
            const fingerprint = localStorage.getItem(LOCAL_STORAGE_KEYS.user_rating_fingerprint);
            if (!fingerprint) {
                console.log('Fingerprint not found.');
                return;
            }

            setUploading(true);
            setUploadProgress(0);

            try {
                const totalFiles = files.length;
                for (let i = 0; i < totalFiles; i++) {
                    await uploadSingleFile(fingerprint, files[i], i, totalFiles);
                }
            } catch (error) {
                console.error('Error uploading files:', error);
                alert('An error occurred while uploading the files.');
            } finally {
                setUploading(false);
                setUploadProgress(0);
            }
        },
        deleteFileAction : async (index) => {
            setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        },
        submitAction : () => {
            setShowLoader(true);
            setTimeout(async () => {
                setShowLoader(false);
                const fingerprint_id = localStorage.getItem(LOCAL_STORAGE_KEYS.user_rating_fingerprint);
                const response = await submitProgramDataPublicService(fingerprint_id, uploadedFilesPath);
                if (response.data && response.data.program_application && response.data.added_modules) {
                    console.log('Successfully updated program application:', response.data.program_application);
                    console.log('Successfully added modules:', response.data.added_modules);
                    history.push('/rating/company-program-info');
                }
            }, 2000);
        },
    };

    // Configuration options for visual appearance
    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    if (uploading)
    {
        return (
            <LoaderBackDropWithPercentage
            loading={uploading}
            value={uploadProgress}
        />
        );
    }

    // Rendering the ProductDisplay view component
    return (
        <div>
            <ProgramRatingView
                data={data}
                actions={actions}
                options={options}
            />
        </div>
    );
};

export default ProgramRatingMain;